import {Order} from './Order';

export interface Options {
    onComplete: ((obj: any) => void),
    onFailure: ((obj: any) => void)
}

export const enum AssetType {
    Entity = 1, Option = 2, MutualFund = 3, Bond = 4, Undefined = 0,
}
export const enum CharAssetType {
    Entity = 'E', Option = 'O', MutualFund = 'M', Bond = 'B', Undefined = 'U',
}

export const enum PositionEffect {
    Unknown = 0, Open = 1, Close = 2,
}

export const enum OrderDuration {
    Unknown = 0,
    Day = 1,
    GTC = 2,
    ETH = 3,
    Manual = 4,
}

export const enum OrderAction {
    Unknown = 0,
    Buy = 1,
    Sell = 2,
}

export const enum OrderClass {
    Unknown = 0,
    Single = 1,
    Spread = 2,

}

export const enum OrderStatus {
    Undefined = 0,
    New = 1,
    PartiallyFilled = 2,
    Filled = 3,
    // DoneForDay = 4,
    Cancelled = 5,
    Replaced = 6,
    PendingCancel = 7,
    // CxldEndOfDay = 8,
    Rejected = 9,
    // Suspended = 10,
    PendingNew = 11,
    // Calculated = 12,
    Expired = 13,
    PendingReplace = 14,
    Saved = 15,
    // LiveUntriggered = 16,
    // Scheduled = 17,
    // OCOUntriggered = 18,
    // CancelledUntriggered = 19,
    Initiated = 20,
    ReplaceInitiated = 21,
    CancelInitiated = 22,
    CancelRejected = 23,
    // ReplaceRejected = 24,
    // Busted = 25,
    PreAllocated = 26,
}

export const enum OrderType {
    Unknown = 0,
    Market = 1,
    Limit = 2,
    StopMarket = 3,
    StopLimit = 4,
    MarketOnClose = 5,
}

export enum DebitCredit {
    Unknown = -1,
    Debit = 1,
    Credit = 2,
}
export namespace DebitCredit {
    export function isValid(mode: DebitCredit) {
        return mode === DebitCredit.Credit || mode === DebitCredit.Debit;
    }
    export function GetAnother(mode: DebitCredit) {
        switch  (mode) {
            case DebitCredit.Unknown: return DebitCredit.Debit;
            case DebitCredit.Debit: return DebitCredit.Credit;
            case DebitCredit.Credit: return DebitCredit.Debit;
        }
    }

    export function GetCaption(mode: DebitCredit) {
        switch (mode) {
            case DebitCredit.Unknown:
                return 'Debit/Credit';
            case DebitCredit.Debit:
                return 'Debit';
            case DebitCredit.Credit:
                return 'Credit';
        }
    }

    export function GetAbbr(mode: DebitCredit) {
        switch (mode) {
            case DebitCredit.Unknown:
                return 'DR/CR';
            case DebitCredit.Debit:
                return 'DR';
            case DebitCredit.Credit:
                return 'CR';
        }
    }
}



export interface ExtendedQuoteDTO {
    PreviousAsk: number;
    PreviousBid: number;
    PreviousClose: number;
    CloseDate: string;
    NetAssetValue: number;
    YTDReturn: number;
    OfferPrice: number;
    SymbolName: null,
    InternalSymbol: null,
    Low52Week: number;
    High52Week: number;
    AvgVolume: number;
    Shares: number;
    DividendType: number;
    ExDivDate: string;
    DivDate: string;
    RegDivFrequency: number;
    RegDivAmount: number;
    SpecialDivAmount: number;
    SpecialDivFrequency: number;
    SpecialDivDate: string;
    SpecialDivExDate: string;
    EPS: number;
    Issuer: number;
    MarketCap: number;
    Yield: number;
    PERatio: number;
    High52WeekDate: string;
    Low52WeekDate: string;
    AvgVolume10Day: number;
    Beta: number;
    ShortInterest: number;
    SicCode: number;
    PrimaryExchange: null;
    IssueType: number;
}
export interface Quote {
    Symbol: string;
    LastTradePrice: number;
    AskPrice: number;
    BidPrice: number;
    NetChange: number;
    AskSize?: number;
    AssetClass: number
    BidAskMidPrice: number
    BidSize: number
    CloseDate: string
    ClosePrice: number
    High: number
    IsError: boolean
    Latency: number
    Low: number
    Multiplier: number
    Open: number
    PreviousClose: number
    UnderlyingPrice: number
    UnderlyingSymbol: string
    Volume: number;
    ExtendedQuote: ExtendedQuoteDTO;
}

export interface BlogLink {
    Link: string;
    Title: string;
}

export interface RootState {
    // Orders: {
    //     Total: number;
    //     Items: Order[];
    // }
    order: Order;
    canChangeLegsSymbols: boolean;
}


export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export interface HistoricalEntry {
  Open: number;
  Close: number;
  AdjustedClose: number;
  Min: number;
  Max: number;
  Volume: number;
  Date: Date;
  date2: Date;
  Rule: any;
  Change: number;
  DateStr: string;
}
export interface ChartData {
  HistoricalData: HistoricalEntry [];
  HistoricalPredictions: any[];
  Predictions: any[];
  Period: number;
  LastAveragePrice: number;
  PredictionErrorsStdDev: {
    Min: number;
    Max: number;
  };
}

export interface Portfolio {
    id: number;    
}
